import React from 'react';
import PropTypes from 'prop-types';

// The coordinates of a dealer's warehouse. The data team builds and registers that
// warehouse; we only point at it, so every label here is about *connecting*, never
// about creating. The backend authenticates with its own managed identity — these
// fields are addresses, not credentials.
export const DEFAULT_DATABASE = 'sqldb-main';

export const emptySource = () => ({
    synapse_server: '',
    lake_account: '',
    database: DEFAULT_DATABASE,
    is_demo: false,
});

function DataSourceFields({ value, onChange, disabled, autoFocus }) {
    const set = (patch) => onChange({ ...value, ...patch });

    return (
        <>
            <label className="ac-field">
                <span>Synapse endpoint</span>
                <input
                    type="text"
                    autoFocus={autoFocus}
                    disabled={disabled}
                    placeholder="dealer-syn-ondemand.sql.azuresynapse.net"
                    value={value.synapse_server}
                    onChange={(e) => set({ synapse_server: e.target.value })}
                />
            </label>
            <label className="ac-field">
                <span>Storage account <span className="ac-field-opt">optional</span></span>
                <input
                    type="text"
                    disabled={disabled}
                    placeholder="stdealerlake"
                    value={value.lake_account}
                    onChange={(e) => set({ lake_account: e.target.value })}
                />
            </label>
            <label className="ac-field">
                <span>Database</span>
                <input
                    type="text"
                    disabled={disabled}
                    placeholder={DEFAULT_DATABASE}
                    value={value.database}
                    onChange={(e) => set({ database: e.target.value })}
                />
            </label>
            <label className="ac-check">
                <input
                    type="checkbox"
                    disabled={disabled}
                    checked={!!value.is_demo}
                    onChange={(e) => set({ is_demo: e.target.checked })}
                />
                <span>Demo source — sample data, not this dealer&apos;s live warehouse</span>
            </label>
            <p className="ac-modal-hint">
                The data team hands you these when the dealer&apos;s warehouse is registered.
                We only read from it — connecting here builds nothing.
            </p>
        </>
    );
}

DataSourceFields.propTypes = {
    value: PropTypes.shape({
        synapse_server: PropTypes.string,
        lake_account: PropTypes.string,
        database: PropTypes.string,
        is_demo: PropTypes.bool,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
};

export default DataSourceFields;
